module.exports = __webpack_public_path__ + "static/media/event_logo_without_shadow.2bd49e92.png";